'use strict';

require("core-js/modules/esnext.promise.all-settled.js");

var requirePromise = require('./requirePromise');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  requirePromise();
  return typeof Promise.allSettled === 'function' ? Promise.allSettled : implementation;
};